<ion-header>
  <ion-toolbar>
    <ion-title>Automation Run Logs</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="getLogs()"> Refresh </ion-button>
      <ion-button (click)="copyToClipboard()"> Copy to clipboard </ion-button>
      <ion-button (click)="hideMetadata = !hideMetadata; getLogs()">
        {{ hideMetadata ? 'Show metadata' : 'Hide metadata' }}
      </ion-button>
      <ion-button (click)="dismiss()"><ion-icon name="close"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <ion-list lines="none">
    <ng-container *ngIf="automationRunLogs?.length">
      <ion-item *ngFor="let log of automationRunLogs">
        <pre style="margin: 0; text-wrap: wrap">{{ log }}</pre>
      </ion-item>
    </ng-container>
    <ng-container *ngIf="isLoading">
      <ion-item>
        <ion-spinner name="crescent"></ion-spinner>
      </ion-item>
    </ng-container>
    <ng-container *ngIf="!isLoading && !automationRunLogs?.length">
      <ion-item>
        <ion-label>
          <h3>No logs available for this automation run.</h3>
          <p>Logs are only available for 30 days</p>
        </ion-label>
      </ion-item>
    </ng-container>
  </ion-list>
</ion-content>
